import { useTranslation } from 'react-i18next'

import { useDateLimits, useTimeZone } from '../../../../../../hooks'
import { stopPropagation } from '../../../../../../utils/events'
import { DatePicker } from '../../../../../DateTime'
import { EntityProfileHeaderInfoItemBase } from '../../../../../Entity'
import { Status } from '../../../../../Status'
import Text from '../../../../../Text'
import { QA_NAME_LISTING_PROFILE_INFO_AVAILABLE_FROM } from '../RentalPortalListingProfileHeaderInfoItems.constants'
import {
  getListingAvailableFromTextColor,
  getListingShortDate,
} from '../RentalPortalListingProfileHeaderInfoItems.utils'

import {
  LISTING_PROFILE_AVAILABLE_FROM_ACTIONS,
  QA_NAME_LISTING_PROFILE_AVAILABLE_FROM_INPUT,
} from './ListingProfileAvailableFromItem.constants'
import { useListingProfileAvailableFromEdit } from './ListingProfileAvailableFromItem.hooks'
import {
  getListingProfileAvailableFromContentWrapperProps,
  getListingProfileAvailableFromHandlers,
} from './ListingProfileAvailableFromItem.utils'

import * as styles from './ListingProfileAvailableFromItem.module.css'

function ListingProfileAvailableFromItem({
  canEdit,
  className,
  contentWrapperClassName,
  isInactive,
  titleClassName,
  value,
  onSaveValue,
  ...restProps
}) {
  const { t } = useTranslation()

  const timezone = useTimeZone()

  const { maxDate, minDate } = useDateLimits()

  const {
    dateInputRef,
    editContainerRef,
    editValue,
    handleChangeEditValue,
    handleDeleteValue,
    handleStartEditing,
    hasError,
    isEditing,
    isSaving,
  } = useListingProfileAvailableFromEdit({ value, onSaveValue })

  function handleClickDelete(event) {
    stopPropagation(event)

    handleDeleteValue()
  }

  return isEditing ? (
    <div className={className}>
      <Text isSecondary className={titleClassName}>
        {t(restProps.title)}
      </Text>
      <div className={styles.editFieldsWrapper} ref={editContainerRef}>
        <DatePicker
          autoFocus
          disabled={isSaving}
          maxValue={maxDate}
          minValue={minDate}
          placeholder={t('RentalPortal.ListingFormAvailableFromPlaceholderKey')}
          qaName={QA_NAME_LISTING_PROFILE_AVAILABLE_FROM_INPUT}
          ref={dateInputRef}
          showError={hasError}
          value={editValue}
          wrapperClassName={styles.datePickerWrap}
          onChange={handleChangeEditValue}
        />
      </div>
    </div>
  ) : (
    <EntityProfileHeaderInfoItemBase
      {...restProps}
      actions={canEdit ? LISTING_PROFILE_AVAILABLE_FROM_ACTIONS : null}
      canEdit={canEdit}
      className={className}
      contentExist={Boolean(value)}
      contentWrapperClassName={contentWrapperClassName}
      contentWrapperProps={getListingProfileAvailableFromContentWrapperProps({
        canEdit,
        onClick: handleStartEditing,
      })}
      handlers={getListingProfileAvailableFromHandlers(handleClickDelete)}
      titleClassName={titleClassName}
      value={value}
    >
      {value ? (
        <Status
          qaName={QA_NAME_LISTING_PROFILE_INFO_AVAILABLE_FROM}
          text={getListingShortDate(value)}
          textColor={getListingAvailableFromTextColor({
            isInactive,
            timezone,
            value,
          })}
        />
      ) : (
        <Text
          disabled
          isSecondary
          qaName={QA_NAME_LISTING_PROFILE_INFO_AVAILABLE_FROM}
        >
          {t('Select.NoDataKey')}
        </Text>
      )}
    </EntityProfileHeaderInfoItemBase>
  )
}

export default ListingProfileAvailableFromItem
